// extracted by mini-css-extract-plugin
export default {"back":"Profile_back__ZFkr9","email":"Profile_email__5fNFV","mainActions":"Profile_mainActions__Gwp6C"};